module.exports = __webpack_public_path__ + "static/media/help.1ede3ad8.svg";